export default __webpack_public_path__ + "89377a82177a13f544c83d4e90c49796.png";